import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.replace"; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { icons } from '~/layout/styleguide/utils/icon-map';
import StatusBadge from './StatusBadge';
export default {
  components: {
    StatusBadge
  },

  data() {
    return {
      section: '',
      isActive: false,
      icons
    };
  },

  props: {
    isSynced: Boolean,
    name: String,
    description: String,
    showHero: Boolean,
    status: {
      type: String,
      default: ''
    }
  },

  mounted() {
    this.isActive = window.location.hash.replace('#', '') === this.name.toLowerCase().replace(/\s+/g, '-');
    this.$root.$on('updateView', title => {
      this.isActive = this.name === title;
    });
    this.section = this.$parent.$props.name;
  }

};